<template>
  <v-card>
    <v-card-text>
      <p class="text-left">{{ text }}</p>
      <div class="d-flex flex-row">
        <div>
          <v-img contain width="50" height="50" style="border-radius:50%" :src="image" />
        </div>
        <div class="pl-3 pt-3">
          <a
            target="_blank"
            :href="url"
            style="color: black; cursor: pointer; text-decoration:none"
          >{{ name }} | {{ year }}</a>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TestimonialCard",
  props: {
    image: String,
    text: String,
    name: String,
    year: String,
    url: String
  }
};
</script>

<style>
</style>